'use client';

import { getQueryClient } from '@lib/utils/queryClient';
// import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
// import { Storage } from '@lib/storage'
import { QueryClientProvider } from '@tanstack/react-query';

// const _persister = createAsyncStoragePersister({
//   storage: new Storage(),
// })

export const ReactQueryClientProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  // NOTE: Avoid useState when initializing the query client if you don't
  //       have a suspense boundary between this and the code that may
  //       suspend because React will throw away the client on the initial
  //       render if it suspends and there is no boundary
  const queryClient = getQueryClient();

  // ReactQueryStreamedHydration seems to cause the query to only be fetched once. a bug? a misconfiguration of query client?

  return (
    // <PersistQueryClientProvider
    //   client={queryClient}
    //   persistOptions={{ persister }}
    // >
    <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="ReactQueryClientProvider" data-sentry-source-file="ReactQueryClientProvider.tsx">
      {/*<ReactQueryDevtools initialIsOpen={false} />*/}

      {/* <ReactQueryStreamedHydration> */}
      {children}
      {/* </ReactQueryStreamedHydration> */}
    </QueryClientProvider>
    // </PersistQueryClientProvider>
  );
};